import { render, staticRenderFns } from "./CpuInscriptionMaterial.vue?vue&type=template&id=a22812ba&scoped=true&"
import script from "./CpuInscriptionMaterial.vue?vue&type=script&lang=js&"
export * from "./CpuInscriptionMaterial.vue?vue&type=script&lang=js&"
import style0 from "./CpuInscriptionMaterial.vue?vue&type=style&index=0&id=a22812ba&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a22812ba",
  null
  
)

export default component.exports